const $ = jQuery.noConflict();

'use strict';

const MainScripts = {

	// properties
	$popupOpener: $('.popup-link-cards-opener'),
	$popupContainer: $('.catalog_popup-container'),
	$closeContainer: $('.js-catalog_popup-container-close'),

	// initialize
	init: function() {
		if(MainScripts.$popupOpener.length) {
			MainScripts.$popupOpener.on('click', function() {
				MainScripts.$popupContainer.addClass('is-active');
			});
			MainScripts.$closeContainer.on('click', function() {
				MainScripts.$popupContainer.removeClass('is-active');
			});
		}
	},
};
export default MainScripts;